// Ported verbatim from native/src/editor/activity/plugins/challenge/MagicShowFlow.js:156-167.

'use strict';

const {roleBlocks, getBlockType, totalBlockCount} = require('./helpers');

function evaluate (activityData, simState) {
    const catBlocks = roleBlocks(simState, 'cat');
    const hasOnflag = catBlocks.some((b) => getBlockType(b) === 'onflag');
    const hasHide = catBlocks.some((b) => getBlockType(b) === 'hide');
    const hasShow = catBlocks.some((b) => getBlockType(b) === 'show');

    return {
        success: hasOnflag && hasHide && hasShow,
        usedBlocks: totalBlockCount(simState),
        storyPhase: simState && simState.phaseFlags && simState.phaseFlags.storyPhase || null,
        flagTapCount: simState && simState.phaseFlags && simState.phaseFlags.flagTapCount || 0
    };
}

module.exports = evaluate;
